module.exports = __webpack_public_path__ + "static/media/orange.3ec3d0de.jpg";